import cns from 'classnames';
import { isNil } from 'lodash-es';
import { Stack } from '@zep/ui';
import { fDateTimeByCountryCode } from '../../../../utils';
import { usePlanSpaceDetailContext } from '../plan';
import { PlanSpaceGroup } from '../space/organisms';
import S from './AppliedPlan.module.scss';
export const NextClaimDate = ({
  title
}: NextClaimDateProps) => {
  const {
    spacePlan,
    subscription,
    space
  } = usePlanSpaceDetailContext();
  if (isNil(subscription) && isNil(spacePlan)) return null;
  return <PlanSpaceGroup title={title} data-sentry-element="PlanSpaceGroup" data-sentry-component="NextClaimDate" data-sentry-source-file="NextClaimDate.tsx">
      <Stack direction={'row'} gap={8} style={{
      alignItems: 'flex-end'
    }} data-sentry-element="Stack" data-sentry-source-file="NextClaimDate.tsx">
        <label className={cns(S.label, S.gray)}>
          {fDateTimeByCountryCode(spacePlan?.paymentExpectedDate ?? subscription?.nextCreationDate ?? spacePlan?.endDate ?? Date.now(), space.countryCode)}
        </label>
      </Stack>
    </PlanSpaceGroup>;
};
type NextClaimDateProps = {
  title: string;
};